import { Table } from "@tanstack/react-table";

import {
  FirstPageIcon,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LastPageIcon,
} from "@/icon/shared";

export const Pagination = <T,>({
  table,
  rowsPerPage,
  lang = "zh",
}: {
  table: Table<T>;
  rowsPerPage: number[];
  lang?: "en" | "zh";
}) => (
  <div className="z-30 flex h-12 w-full select-none items-center justify-end gap-3 border-t p-2 text-xs text-neutral-500">
    <select
      className="cursor-pointer appearance-none rounded-md border border-[#CFD6DC] py-1 pl-2 pr-6 text-xs transition-all hover:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500 disabled:cursor-not-allowed"
      style={{
        background: `url("data:image/svg+xml,<svg height='10px' width='10px' viewBox='0 0 16 16' fill='gray' opacity='50' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>") no-repeat`,
        backgroundPosition: "right 0.5rem center",
      }}
      value={table.getState().pagination.pageSize}
      onChange={(e) => {
        table.setPageSize(Number(e.target.value));
      }}
      disabled={table.getRowModel().rows.length === 0}
    >
      {rowsPerPage.map((pageSize) => (
        <option key={pageSize} value={pageSize}>
          {pageSize} {lang === "zh" ? "筆" : "rows"}
        </option>
      ))}
    </select>
    {table.getPageCount() >= 1 && (
      <p className="text-sm">
        {table.getState().pagination.pageIndex + 1}/{table.getPageCount()}
      </p>
    )}
    <div className="flex items-center gap-2">
      <button
        disabled={!table.getCanPreviousPage()}
        onClick={() => table.setPageIndex(0)}
      >
        <FirstPageIcon
          className={
            table.getCanPreviousPage()
              ? "fill-sky-700 transition-opacity hover:opacity-75"
              : "cursor-default fill-stone-300"
          }
        />
      </button>
      <button
        disabled={!table.getCanPreviousPage()}
        onClick={() => table.previousPage()}
      >
        <KeyboardArrowLeft
          className={
            table.getCanPreviousPage()
              ? "fill-sky-700 transition-opacity hover:opacity-75"
              : "cursor-default fill-stone-300"
          }
        />
      </button>
      <button
        disabled={!table.getCanNextPage()}
        onClick={() => table.nextPage()}
      >
        <KeyboardArrowRight
          className={
            table.getCanNextPage()
              ? "fill-sky-700 transition-opacity hover:opacity-75"
              : "cursor-default fill-stone-300"
          }
        />
      </button>
      <button
        disabled={!table.getCanNextPage()}
        onClick={() => table.setPageIndex(table.getPageCount() - 1)}
      >
        <LastPageIcon
          className={
            table.getCanNextPage()
              ? "fill-sky-700 transition-opacity hover:opacity-75"
              : "cursor-default fill-stone-300"
          }
        />
      </button>
    </div>
  </div>
);
